module.exports = __webpack_public_path__ + "img/MK.cff2ddb0.svg";